export const BugIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M26.6668 10.7263V7.49967C26.6668 5.73156 25.9645 4.03587 24.7142 2.78563C23.464 1.53539 21.7683 0.833008 20.0002 0.833008C18.2321 0.833008 16.5364 1.53539 15.2861 2.78563C14.0359 4.03587 13.3335 5.73156 13.3335 7.49967V10.7263"
        fill="#EF4444"
      />
      <path
        d="M20.0002 0.833008C18.2321 0.833008 16.5364 1.53539 15.2861 2.78563C14.0359 4.03587 13.3335 5.73156 13.3335 7.49967V10.7263H13.4002C13.5527 9.08144 14.3141 7.5528 15.5349 6.43994C16.7558 5.32708 18.3482 4.71022 20.0002 4.71022C21.6521 4.71022 23.2445 5.32708 24.4654 6.43994C25.6863 7.5528 26.4476 9.08144 26.6002 10.7263H26.6668V7.49967C26.6668 5.73156 25.9645 4.03587 24.7142 2.78563C23.464 1.53539 21.7683 0.833008 20.0002 0.833008Z"
        fill="#EF4444"
      />
      <path
        d="M26.6668 10.7263V7.49967C26.6668 5.73156 25.9645 4.03587 24.7142 2.78563C23.464 1.53539 21.7683 0.833008 20.0002 0.833008C18.2321 0.833008 16.5364 1.53539 15.2861 2.78563C14.0359 4.03587 13.3335 5.73156 13.3335 7.49967V10.7263"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 39.167C28.2843 39.167 35 32.4513 35 24.167C35 15.8827 28.2843 9.16699 20 9.16699C11.7157 9.16699 5 15.8827 5 24.167C5 32.4513 11.7157 39.167 20 39.167Z"
        fill="#FEE2E2"
      />
      <path
        d="M20 31.8584C16.66 31.8551 13.4167 30.7371 10.7841 28.6817C8.15147 26.6263 6.28013 23.7511 5.46667 20.5117C4.90089 22.7266 4.84884 25.0415 5.31448 27.2795C5.78011 29.5176 6.75113 31.6196 8.15334 33.4251C9.55555 35.2305 11.3519 36.6915 13.4051 37.6966C15.4583 38.7017 17.714 39.2242 20 39.2242C22.286 39.2242 24.5417 38.7017 26.5949 37.6966C28.6481 36.6915 30.4444 35.2305 31.8467 33.4251C33.2489 31.6196 34.2199 29.5176 34.6855 27.2795C35.1512 25.0415 35.0991 22.7266 34.5333 20.5117C33.7199 23.7511 31.8485 26.6263 29.2159 28.6817C26.5833 30.7371 23.34 31.8551 20 31.8584Z"
        fill="#EF4444"
      />
      <path
        d="M15.1915 2.88301L14.1665 0.833008"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8082 2.88301L25.8332 0.833008"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9998 29.9997C23.2215 29.9997 25.8332 27.388 25.8332 24.1663C25.8332 20.9447 23.2215 18.333 19.9998 18.333C16.7782 18.333 14.1665 20.9447 14.1665 24.1663C14.1665 27.388 16.7782 29.9997 19.9998 29.9997Z"
        fill="#EF4444"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8651 36.25C28.3117 35.5141 28.0176 34.6156 28.0289 33.6949C28.0401 32.7742 28.356 31.8832 28.9272 31.161C29.4984 30.4388 30.2927 29.9262 31.1861 29.7032C32.0794 29.4802 33.0215 29.5593 33.8651 29.9284"
        fill="#EF4444"
      />
      <path
        d="M28.8651 36.25C28.3117 35.5141 28.0176 34.6156 28.0289 33.6949C28.0401 32.7742 28.356 31.8832 28.9272 31.161C29.4984 30.4388 30.2927 29.9262 31.1861 29.7032C32.0794 29.4802 33.0215 29.5593 33.8651 29.9284"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.8098 18.3003C33.2654 18.5408 32.6783 18.67 32.0832 18.6803C31.3094 18.6803 30.5509 18.4649 29.8926 18.0581C29.2344 17.6512 28.7024 17.0692 28.3564 16.3771C28.0103 15.685 27.8639 14.9102 27.9333 14.1395C28.0028 13.3688 28.2856 12.6327 28.7498 12.0137"
        fill="#EF4444"
      />
      <path
        d="M33.8098 18.3003C33.2654 18.5408 32.6783 18.67 32.0832 18.6803C31.3094 18.6803 30.5509 18.4649 29.8926 18.0581C29.2344 17.6512 28.7024 17.0692 28.3564 16.3771C28.0103 15.685 27.8639 14.9102 27.9333 14.1395C28.0028 13.3688 28.2856 12.6327 28.7498 12.0137"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1984 36.3151C11.7586 35.5745 12.0691 34.6752 12.0851 33.7467C12.0851 32.6417 11.6461 31.5819 10.8647 30.8005C10.0833 30.0191 9.02348 29.5801 7.91841 29.5801C7.31482 29.5929 6.71965 29.7243 6.16675 29.9667"
        fill="#EF4444"
      />
      <path
        d="M11.1984 36.3151C11.7586 35.5745 12.0691 34.6752 12.0851 33.7467C12.0851 32.6417 11.6461 31.5819 10.8647 30.8005C10.0833 30.0191 9.02348 29.5801 7.91841 29.5801C7.31482 29.5929 6.71965 29.7243 6.16675 29.9667"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.18811 18.3053C6.73343 18.5444 7.32108 18.6719 7.91644 18.6803C8.69024 18.6803 9.44876 18.4649 10.107 18.0581C10.7652 17.6512 11.2972 17.0692 11.6432 16.3771C11.9893 15.685 12.1358 14.9102 12.0663 14.1395C11.9968 13.3688 11.7141 12.6327 11.2498 12.0137"
        fill="#EF4444"
      />
      <path
        d="M6.18811 18.3053C6.73343 18.5444 7.32108 18.6719 7.91644 18.6803C8.69024 18.6803 9.44876 18.4649 10.107 18.0581C10.7652 17.6512 11.2972 17.0692 11.6432 16.3771C11.9893 15.685 12.1358 14.9102 12.0663 14.1395C11.9968 13.3688 11.7141 12.6327 11.2498 12.0137"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6382 13.5933L33.3332 10H35.8332"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6519 34.7285L32.5002 37.5002H35.0002"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3615 13.5933L6.6665 10H4.1665"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.34833 34.7285L7.5 37.5002H5"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4633 20.1787L37.4999 19.167"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6536 27.3848L37.5002 28.3331"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.53667 20.1787L2.5 19.167"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.34667 27.3848L2.5 28.3331"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0835 5C17.194 5 17.3 5.0439 17.3781 5.12204C17.4563 5.20018 17.5002 5.30616 17.5002 5.41667"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6665 5.41667C16.6665 5.30616 16.7104 5.20018 16.7885 5.12204C16.8667 5.0439 16.9727 5 17.0832 5"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0832 5.83366C16.9727 5.83366 16.8667 5.78976 16.7885 5.71162C16.7104 5.63348 16.6665 5.5275 16.6665 5.41699"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5002 5.41699C17.5002 5.5275 17.4563 5.63348 17.3781 5.71162C17.3 5.78976 17.194 5.83366 17.0835 5.83366"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9165 5C23.027 5 23.133 5.0439 23.2111 5.12204C23.2893 5.20018 23.3332 5.30616 23.3332 5.41667"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 5.41667C22.5 5.30616 22.5439 5.20018 22.622 5.12204C22.7002 5.0439 22.8062 5 22.9167 5"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9167 5.83366C22.8062 5.83366 22.7002 5.78976 22.622 5.71162C22.5439 5.63348 22.5 5.5275 22.5 5.41699"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3332 5.41699C23.3332 5.5275 23.2893 5.63348 23.2111 5.71162C23.133 5.78976 23.027 5.83366 22.9165 5.83366"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 39.167C28.2843 39.167 35 32.4513 35 24.167C35 15.8827 28.2843 9.16699 20 9.16699C11.7157 9.16699 5 15.8827 5 24.167C5 32.4513 11.7157 39.167 20 39.167Z"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 9.16699V39.167"
        stroke="#0F172A"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
